import { ThemeProvider } from "@mui/material/styles";
import { AAVO_MUI_THEME } from "src/theme/theme.ts";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import { ErrorDialogContextProvider } from "src/components/common/dialogs/errorDialog/ErrorDialogContextProvider.tsx";
import { ErrorDialogHost } from "src/components/common/dialogs/errorDialog/ErrorDialogHost.tsx";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider as DatePickerLocalizationProvider } from "@mui/x-date-pickers-pro";
import { getLanguageSetting } from "./localSettings/utils";
import { RouterProvider } from "@tanstack/react-router";
import Box from "@mui/material/Box";
import { ErrorBoundary } from "src/sentry/ErrorBoundary.tsx";
import { router } from "src/routing/router.ts";
import { FeatureChangeHintContextProvider } from "src/components/common/featureChangeHint/FeatureChangeHintContextProvider.tsx";
import { PushNotificationsContextProvider } from "./notifications/PushNotificationsContextProvider";
import { TenantCustomizationsContextProvider } from "./tenantCustomizations/TenantCustomizationsContextProvider";

const cache = createCache({
	key: "css",
	prepend: true,
});

export const App = () => (
	<Box
		sx={{
			height: "100%",
			display: "flex",
		}}
	>
		<ErrorBoundary>
			<ThemeProvider theme={AAVO_MUI_THEME}>
				<CacheProvider value={cache}>
					{/*
						 Customized errors views are disabled here,
						 because they may use some context which is not yet provided.
						 Another ErrorDialogContextProvider with customized views are provided later in the component tree.
						 */}
					<ErrorDialogContextProvider disableCustomizedErrorViews>
						<ErrorDialogHost />
						<PushNotificationsContextProvider>
							<TenantCustomizationsContextProvider>
								<FeatureChangeHintContextProvider>
									<DndProvider backend={HTML5Backend}>
										<DatePickerLocalizationProvider
											dateAdapter={AdapterDayjs}
											adapterLocale={getLanguageSetting()}
										>
											<RouterProvider router={router} />
										</DatePickerLocalizationProvider>
									</DndProvider>
								</FeatureChangeHintContextProvider>
							</TenantCustomizationsContextProvider>
						</PushNotificationsContextProvider>
					</ErrorDialogContextProvider>
				</CacheProvider>
			</ThemeProvider>
		</ErrorBoundary>
	</Box>
);
